import { createTheme } from '@mui/material/styles';
import {
  colorPrimaryDeepBlue,
  colorPrimarySeaGreen,
  colorSemanticError,
  colorSemanticInfo,
  colorSemanticSuccess,
  colorSemanticWarning,
  fontFamilyJa,
} from './tokens';

export const agentTheme = createTheme({
  palette: {
    primary: { main: colorPrimaryDeepBlue },
    secondary: { main: colorPrimarySeaGreen },
    error: { main: colorSemanticError },
    warning: { main: colorSemanticWarning },
    info: { main: colorSemanticInfo },
    success: { main: colorSemanticSuccess },
  },
  typography: {
    fontFamily: fontFamilyJa,
  },
});
